module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersWidgetCheckboxes":{"showMore":"další"}}}')
  delete Component.options._Ctor
}
